import React, { useState, useEffect, useCallback } from 'react';

let logoutTimer;

const AuthContext = React.createContext({
  token: '',
  isLoggedIn: false,
  login: () => {},
  logout: () => {},
});

// funkcija koja izracunava preostalo vreme (trajanje tokena)
const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();
  const remainingDuration = adjExpirationTime - currentTime;
  return remainingDuration;
};

// funkcija koja vraca token i preostalo vreme,
// ako je korisnik ugasio app pa se kasnije vratio a token jos uvek traje
const retrieveStoredToken = () => {
  const storedToken = localStorage.getItem('token');
  const storedExpirationTime = localStorage.getItem('expirationTime');

  const remainingTime = calculateRemainingTime(storedExpirationTime);
  if (remainingTime <= 60000) {
    // 1 minut
    localStorage.clear();
    return null;
  }
  return { token: storedToken, duration: remainingTime };
};

export function AuthContextProvider(props) {
  const tokendData = retrieveStoredToken();
  let initialToken;
  if (tokendData) {
    initialToken = tokendData.token;
  }
  const [token, setToken] = useState(initialToken);

  const userIsLoggedIn = !!token;

  // logout handler funkcija
  const logoutHandler = useCallback(() => {
    setToken(null);
    localStorage.clear();
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, []);

  // Login hendler f-ja sa login strane dobija token i trajanje tokena
  const loginHandler = (
    token,
    expirationTime,
    idKorisnika,
    korisnik,
    idMenija,
    slikaURL,
    magacioner,
    boja,
    supervizor,
    sa,
    idOsobe,
    idOrgJed,
    idKupca,
    chatToken,
    uniqueUser,
  ) => {
    setToken(token);
    localStorage.setItem('token', token);
    localStorage.setItem('expirationTime', expirationTime);
    localStorage.setItem('idKorisnika', idKorisnika);
    localStorage.setItem('korisnik', korisnik);
    localStorage.setItem('idMenija', idMenija);
    localStorage.setItem('SlikaURL', slikaURL);
    localStorage.setItem('magacioner', magacioner);
    localStorage.setItem('boja', boja);
    localStorage.setItem('supervizor', supervizor);
    localStorage.setItem('sa', sa);
    localStorage.setItem('idOsobe', idOsobe);
    localStorage.setItem('idOrgJed', idOrgJed);
    localStorage.setItem('idFirme', idKupca);
    localStorage.setItem('chatToken', chatToken);
    localStorage.setItem('uniqueUser', uniqueUser === true);
    // pozvi f-je koja izracunava preostalo vreme
    const remainingTime = calculateRemainingTime(expirationTime);

    logoutTimer = setTimeout(logoutHandler, remainingTime);
  };

  useEffect(() => {
    if (tokendData) {
      logoutTimer = setTimeout(logoutHandler, tokendData.duration);
    }
  }, [tokendData, logoutHandler]);

  const contextValue = {
    token,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
